import React from 'react';

import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';

class Unauthorized extends React.Component {

    componentDidMount() {
        this.trackPage();
    }

    trackPage() {
        api.get('/track/unauthorized');
    }

    render() {

        return (

            <div className="container app-container">
                <Grid container justify="center" alignItems="center">
                    <Grid item>
                        <div className="tc">
                            <Typography variant="h2" color="primary">403</Typography>
                            <Typography variant="h4" color="textSecondary" gutterBottom>Unauthorized Action</Typography>
                            <Typography variant="body1">
                                Looks like you've lost your way. Please use the navigation or click <a href="/">here</a> to get back.
                            </Typography>
                        </div>
                    </Grid>
                </Grid>
            </div>

        );
    }
}

export default Unauthorized;
